import { render, staticRenderFns } from "./ActiveBody.vue?vue&type=template&id=c21af63e&scoped=true&"
import script from "./ActiveBody.vue?vue&type=script&lang=ts&"
export * from "./ActiveBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21af63e",
  null
  
)

export default component.exports